import React from 'react';
import styled from 'styled-components';

import offerLongtime from '../../assets/icons-fleet/icon-offer-longtime.svg';

const ContactStepWrapper = styled.div`
    img {
        display: block;
        height: 250px;
        margin: 0 auto;
        margin-top: 55px;
    }

    h4 {
        display: block;
        font-size: 26px;
        line-height: 35px;
        max-width: 450px;
        margin: 50px auto 60px;
        text-align: center;
        text-transform: none;
    }

    button {
        display: block;
        margin: 0 auto;
        padding: 13px 25px 13px 70px;

        &:after {
            transform: rotate(180deg);
            top: 17px;
            left: 27px;
            right: 0;
        }
    }
`;

class ContactStep3 extends React.Component {
    render() {
        const typeOfContact =
            this.props.values.typeOfContact === 'phone'
                ? 'telefonicznie'
                : 'mailowo';

        return (
            <ContactStepWrapper>
                <img src={offerLongtime} alt="offerLongtime" />
                <h4>
                    Nasz pracownik skontaktuje się z Tobą{' '}
                    <span className="color-orange">{typeOfContact}</span> w
                    ciągu 24 godzin.
                </h4>
                <button
                    className="btn-general btn-general--primary"
                    onClick={this.props.closeModal}
                >
                    Wróć do przeglądania
                </button>
            </ContactStepWrapper>
        );
    }
}

export default ContactStep3;
